import client from '@/api/client.js'
import store from "@/store";
import i18n from '@/plugins/i18n.js';

export default {
    methods: {
        async searchArticle(searchParameter) {
            var meta = {
                clientApiMethod: 'getArticle',
                input: { q: searchParameter },
                noClutter: true,
                icon: "mdi-information-outline",
                color: "warning",
                onErrorMessage: (event) => event.response.data.Message
            }
            var response = await client().get(store.state.apiRouteRoot + "article/search?q=" + encodeURI(searchParameter), { meta: meta });
            return response.data;
        },

        async createArticle(article, image) {
            //console.log('article', article, image);
            let formData = new FormData();
            if (image) {
                formData.append("ImageFile", image, image.name);
            }
            formData.append("Article", JSON.stringify(article));
            var meta = {
                clientApiMethod: 'createArticle',
                input: { article },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.article.article") }),
            }
            var response = await client().post(store.state.apiRouteRoot + "Article/", formData, {
                headers: { "Content-Type": "multipart/form-data" },
                transformRequest: formData => formData,
                meta: meta
            });
            return response?.data;
        },

        async updateArticle(article, image) {
            //console.log('article', article, image);
            let formData = new FormData();
            if (image) {
                formData.append("ImageFile", image, image.name);
            }
            formData.append("Article", JSON.stringify(article));
            var meta = {
                clientApiMethod: 'updateArticle',
                input: { article },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.article.article") }),
            }
            var response = await client().patch(store.state.apiRouteRoot + "Article/", formData, {
                headers: { "Content-Type": "multipart/form-data" },
                transformRequest: formData => formData,
                meta: meta
            });
            return response?.data;
        },

        async searchArticleByString(query) {
            var meta = { clientApiMethod: 'searchArticleByString', input: { query: query } }
            var querystring = encodeURI(query)
            var response = await client().get('/api2/serviceprovider/article/search?q=' + querystring, { meta: meta })
            return response?.data;
        },

        async getArticleListFromFilter(filter, cancelationToken) {
            //console.log("getArticleListFromFilter", filter);
            var meta = { clientApiMethod: 'getArticleListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Article/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        
        async getArticle(articleNumber) {
            console.log("getArticle", articleNumber);
            var encodedArticleNumber = encodeURIComponent(articleNumber)
            var meta = { clientApiMethod: 'getArticle', input: { articleNumber: encodedArticleNumber } }
            var response = await client().get(store.state.apiRouteRoot + "Article/" + encodedArticleNumber, { meta: meta })
            return response?.data;
        },
    }
}